import { styled, ThemeDefinition } from "@vw-marketing/us-components";

export const StyledErrorContainer: any = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 60svh;
  justify-content: center;
  position: relative;
  top: -30px;
`;

export const StyledErrorHeaderContainer: any = styled.div`
  ${({ theme }: { theme: ThemeDefinition }) => {
    return `
      align-items: center;
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static300};
      justify-content: center;

      svg {
        color: ${theme.colors.signal.error};
      }
    `;
  }}
`;

export const StyledDescriptionContainer: any = styled.div`
  ${({ theme }: { theme: ThemeDefinition }) => {
    return `
      align-items: center;
      display: flex;
      justify-content: center;
      padding-top: ${theme.size.static150};
    `;
  }}
`;
